import Table from 'react-bootstrap/Table';
import React, { useState, useEffect } from "react";
import { formatType, formatStatus } from "../../helpers/utils.js";

const Tabela = (props) => {
  const [nextSize, setNextSize] = useState(0);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if ( props.rows && (props.rows.length - props.viewSize) < props.viewSize) {
      setNextSize(props.rows.length - props.viewSize)
    }
    else {
      setNextSize(props.viewSize)
    }

    if(props.rows){
      setRows(props.rows.slice(0, props.viewSize))
    }
  }, [props.rows]);

  const growTable = () => {
    if (props.rows && props.rows.length > (rows.length + props.viewSize)) {
      if ((props.rows.length - (rows.length + props.viewSize)) < props.viewSize) {
        setNextSize(props.rows.length - (rows.length + props.viewSize))
      }

      setRows(props.rows.slice(0, rows.length + props.viewSize))
    }
    else {
      setRows(props.rows)
    }
  }

  const formatValue = (value, type) => {
    switch (type) {
      case "money":
        return value + " €";
      case "up":
        return value + " UPs";
      case "type":
        return formatType(value);
      case "status":
        return formatStatus(value, "/");
      default:
        return value;
    }
  }
  
  return (
    <div>
      <Table borderless responsive="md" className="mt-4" id="canvasTable">
        <thead ref={props.refHead}>
          <tr style={{ color: '#3F5B78' }}>
            {(!props.requestsPage) ? <th className="pb-3"></th> : ""}
            {props.columns.map((c, i) => (
              <th key={i} className={"pb-3 " + (c.align === "right" ? 'text-end' : '')} >{c.name}</th>
            ))}
          </tr>
        </thead>
        <tbody ref={props.refBody}>
          {rows.map((r, i) => (
            <tr key={i}
              className={"border-bottom table-row " + ((i === 0 && props.specialFirst) ? 'border-top border-3 border-info' : 'border-primary')}
              id={props.requestsPage ? 'btn-row' : ''}
              role={(!props.requestsPage) ? '' : "button"}
              onClick={() => {
                if (props.onDetailHandler) {
                  props.onDetailHandler(r.id);
                }
              }}
            >
              {(!props.requestsPage) ?
                <td className="align-middle">
                  <svg width="32px" height="32px" viewBox="0 0 32 32">
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <rect fill="#F2F4F8" x="0" y="0" width="32" height="32" rx="8"></rect>
                      <g transform="translate(4.000000, 7.000000)" fill="#0A243E">
                        <path d={props.icon} />
                      </g>
                    </g>
                  </svg>
                </td> : ""}
              {props.columns.map((c, j) => (
                <td key={j} className={"pt-4 pb-3 " + (c.align === "right" ? 'text-end' : '')}>{formatValue(r[c.id], c.type)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
      {(props.rows != null && props.rows != undefined) && ( props.rows.length > rows.length) && (
        <div className="mt-5 text-center">
          <button type="button" className="btn btn-secondary"
            onClick={() => growTable()}
          >
            + {nextSize} {(!props.requestsPage) ? 'movimentos' : 'resultados'}
          </button>
        </div>
      )}
    </div>
  );
};

export default Tabela;
